import React from "react";

export const DefaultTermsAndConditionCa = (
  <div style={{ paddingRight: "8px" }}>
    <div style={{ marginTop: " 8px" }}>
      <h2 style={{ textAlign: "center" }}>
        Termes i Condicions de la Plataforma Nemuru
      </h2>
      <h3 style={{ marginTop: 0 }}>
        <strong>
          Si us plau, llegeixi atentament aquests termes i condicions (els "T&C"
          o "Termes i Condicions") abans d'acceptar-los o d'utilitzar la
          Plataforma o els Serveis de Nemuru.
        </strong>
      </h3>
    </div>
    <p>
      Aquests Termes i Condicions constitueixen un acord vinculant entre (i)
      Nemuru Digital, S.L. (d'ara endavant, <span>&nbsp;</span>
      <strong>"Nemuru"</strong> o la<span>&nbsp;</span>
      <strong>"Companyia"</strong>), entitat constituïda d'acord amb la
      legislació espanyola, domiciliada a l'Edifici Palau de Mar, Plaça Pau
      Vila, número 1, 1a planta, sector AD, oficina 1AD, Barcelona, provista de
      NIF B-67.183.574, inscrita al Registre Mercantil de Barcelona, en el volum
      46.381, foli 118 i full B-518.127 i al Registre Estatal d'Intermediaris
      Financers amb el número 873/2018 de la secció 2ª; i (ii) l'usuari que
      utilitza la Plataforma i/o en gaudeix dels Serveis prestats per Nemuru (l'
      <strong>"Usuari"</strong> i, conjuntament amb Nemuru, les{" "}
      <strong>"Parts"</strong>).
    </p>
    <p>
      Mitjançant l'acceptació d'aquests T&C i l'ús de la Plataforma de Nemuru,
      l'Usuari manifesta i garanteix a Nemuru (i) que els T&C els està
      formalitzant o acceptant en el seu propi nom i representació (en el cas
      que sigui una persona física) o en nom i representació de l'Usuari (en el
      cas que sigui una persona jurídica), així com, en aquest últim cas, que té
      capacitat suficient per vincular i acceptar aquests T&C en nom i
      representació de l'Usuari; (ii) que és major d'edat i té la capacitat
      legal suficient per acceptar aquests T&C (en el cas que sigui una persona
      física); i (iii) coneix i accepta aquests T&C, incloent la{" "}
      <a href="https://nemuru.com/privacidad-intermediacion" target="_blank">
        política de privacitat
      </a>{" "}
      (la<span>&nbsp;</span>
      <strong>"Política de Privacitat"</strong>) i la
      <a href="https://nemuru.com/cookies" target="_blank">
        política de cookies
      </a>{" "}
      (la
      <span>&nbsp;</span>
      <strong>"Política de Cookies"</strong>) de Nemuru, que s'incorporen a
      aquests T&C per referència. Si no està d'acord o no desitja acceptar els
      documents anteriors, no ha d'accedir a la Plataforma ni gaudir dels
      Serveis prestats per Nemuru a través de la mateixa.
    </p>

    <ol>
      <li>
        <h3>
          <strong>Objecte</strong>
        </h3>
        <ol>
          <li>
            <h4>
              <strong>Objecte: </strong>
            </h4>
            <span>
              L'objecte d'aquests T&C és establir els termes i condicions que
              regiran l'ús i els serveis prestats per Nemuru a través de la
              plataforma de Nemuru (la <strong>"Plataforma"</strong>),
              accessible a través de{" "}
              <a href="http://www.nemuru.com">www.nemuru.com</a>, així com de
              els seus subdominis i/o directoris i/o aplicacions mòbils i/o
              qualsevol altre dispositiu.
            </span>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Validació</strong>
        </h3>
        <ol>
          <li>
            <h4>
              <strong>Procés de validació: </strong>
            </h4>
            <span>
              Prèviament a la formalització d'aquests T&C i durant la vigència
              dels mateixos, l'Usuari haurà de facilitar a Nemuru tota aquella
              documentació o informació que se li sol·liciti a efectes que
              Nemuru i, en el seu cas, qualsevol tercer designat per Nemuru,
              puguin dur a terme un procés de diligència deguda de l'Usuari, amb
              l'abast que Nemuru consideri oportú o convenient (el
              <strong>"Procés de Validació"</strong>). Nemuru podrà facilitar
              als corresponents Prestadors la informació facilitada per l'Usuari
              durant el Procés de Validació, a efectes que, si correspon, Nemuru
              o els Prestadors puguin complir amb les seves obligacions en
              matèria de prevenció del blanqueig de capitals i finançament del
              terrorisme o qualsevol altra Legislació Aplicable. A més a més,
              Nemuru podrà obtenir informació addicional relativa a l'Usuari de
              fonts externes.
            </span>
          </li>
          <li>
            <h4>
              <strong>Registre: </strong>
            </h4>
            <span>
              Nemuru podrà sol·licitar a l'Usuari que, per utilitzar la
              Plataforma i qualsevol de les funcionalitats de la mateixa o dels
              Serveis prestats per Nemuru, l'Usuari hagi de crear el seu compte
              personal (la <strong>"Compte"</strong>), per a la qual cosa haurà
              de facilitar determinada informació personal, que serà tractada
              sempre d'acord amb la Política de Privacitat de Nemuru. Aquest
              Compte serà personal i les seves dades d'accés estrictament
              confidencials, pel que l'Usuari serà plenament responsable de
              l'activitat que es desenvolupi en el seu Compte i Nemuru en cap
              cas serà responsable de les pèrdues o danys que l'Usuari pugui
              patir com a conseqüència que una altra persona utilitzi el Compte
              i/o accedeixi o utilitzi el contingut previst en el mateix. De la
              mateixa manera, l'Usuari serà responsable de qualsevol pèrdua o
              dany causat per l'ús del seu Compte, independentment de si està
              sent utilitzada per un tercer. Per mantenir el control sobre el
              Compte i evitar que qualsevol persona hi accedeixi, l'Usuari haurà
              de mantenir el control sobre els dispositius que s'utilitzen per
              accedir al servei i no revelar a ningú la contrasenya o els
              detalls del mètode de pagament associat al Compte. L'Usuari és
              responsable d'actualitzar i mantenir la precisió de la informació
              que proporcioni a Nemuru en relació amb el Compte. Si es
              descobreix o hi ha sospita de qualsevol ús no autoritzat del
              Compte, Nemuru pot cancel·lar o bloquejar el mateix front al
              robatori d'identitat o altres activitats fraudulentes.
            </span>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Serveis</strong>
        </h3>
        <ol>
          <li>
            <span>
              La finalitat de la Plataforma és oferir serveis d'intermediació
              (els <strong>"Serveis"</strong>), que permetin a l'Usuari la
              possibilitat d'optar a finançament (el{" "}
              <strong>"Finançament"</strong>), a concedir per part d'un
              prestador independent (el <strong>"Prestadors"</strong>), per a la
              compra de béns o contractació de serveis a un professional o
              empresa (els <strong>"Comerços"</strong>).
            </span>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Prestadors i Procés de Finançament</strong>
        </h3>
        <ol>
          <li>
            <h4>
              <strong>Condicions de Finançament: </strong>
            </h4>
            <span>
              El Prestador que podrà concedir el Finançament i que es detallarà
              a la proposta serà determinat en funció dels acords que Nemuru
              tingui vigents en cada moment. Les condicions del finançament a
              concedir per part del Prestador seran les facilitades en cada
              moment i que es detallaran a l'oferta de Finançament remesa a
              l'Usuari.
            </span>
          </li>
          <li>
            <h4>
              <strong>Proposta de Préstec: </strong>
            </h4>
            <span>
              Després de la revisió de la documentació o informació facilitada,
              es durà a terme el Procés de Validació, tant per part de Nemuru
              com del Prestador que correspongui. En el supòsit que el Procés de
              Validació sigui satisfactori, s'enviarà a l'Usuari la proposta o
              oferta de Finançament juntament amb la proposta de préstec (la{" "}
              <strong>"Proposta de Préstec"</strong>). En cas que el Procés de
              Validació no sigui superat, s'informarà d'aquesta circumstància i
              l'Usuari no podrà optar al Finançament. En tot cas, en el supòsit
              que es decideixi no concedir el Finançament, l'Usuari no tindrà
              dret a cap mena de compensació i ni Nemuru ni el Prestador estaran
              obligats a concedir el Finançament ni abonar a l'Usuari cap
              quantitat com a conseqüència de tot això.
            </span>
            <p>
              A efectes aclaridors, l'acceptació de la sol·licitud de registre
              de l'Usuari o l'enviament de qualsevol documentació per part de
              Nemuru no comporta, en cap cas, l'acceptació automàtica, per part
              del Prestador, de l'oferta de finançament proposada inicialment.
            </p>
          </li>
          <li>
            <h4>
              <strong>Contracte de Préstec: </strong>
            </h4>
            <span>
              Amb caràcter posterior a la conformitat de la Proposta de Préstec
              per part del Prestador, es posarà a disposició de l'Usuari la
              informació que correspongui de conformitat amb la normativa
              aplicable. La mencionada informació serà posada a disposició de
              l'Usuari per part de Nemuru o del Prestador, segons hagin pactat
              prèviament aquestes últimes. Amb caràcter posterior, el Prestador
              i l'Usuari subscriuran el contracte de préstec (
              <strong>"Contracte de Préstec"</strong>). El Contracte de Préstec
              haurà de ser signat per l'Usuari i el Prestador a través del mitjà
              acordat entre Nemuru i el Prestador. En tot cas, previsiblement es
              formalitzarà:
            </span>
            <ul>
              <li>
                A través de la Plataforma i mitjançant el sistema de firma
                electrònica que Nemuru posarà a disposició de l'Usuari i del
                Prestador
              </li>
              <li>
                A través de la plataforma electrònica que utilitzi el Prestador.
              </li>
            </ul>
          </li>
          <li>
            <h4>
              <strong>Desemborsament: </strong>
            </h4>
            <span>
              Un cop el Comerç hagi comunicat l'inici dels serveis o la venda
              dels productes, i del mateix mode, l'Usuari hagi confirmat l'inici
              dels serveis i/o la compra dels productes, es signarà el Contracte
              de Préstec i es transferirà l'import del Préstec al compte
              titularitat del Comerç de conformitat amb el següent.
            </span>
            <p>
              Després de la formalització del Contracte de Préstec, el Préstec
              serà desemborsat pel Prestador en un compte oberta a nom del
              Comerç o, si s'escau, en una entitat de pagament o en una entitat
              de diners electrònics o en qualsevol altre compte bancari, tot
              això de conformitat amb les condicions generals formalitzades
              entre el Comerç i Nemuru i en el corresponent Contracte de
              Préstec.
            </p>
          </li>
          <li>
            <h4>
              <strong>Oposició de l'Usuari: </strong>
            </h4>
            <p>
              En cas que l'Usuari tingui algun tipus d'oposició en relació amb
              el servei prestat o al producte venut pel Comerç, l'Usuari haurà
              de contactar amb el Comerç als efectes de traslladar aquesta
              oposició i assolir un acord, sense que Nemuru tingui cap mena de
              responsabilitat en relació amb això.
            </p>
            <p>
              Addicionalment, en cas que en el curs de la prestació dels
              serveis, l'Usuari interposés una reclamació al Comerç per no estar
              d'acord amb el resultat dels treballs objecte dels serveis ja
              realitzats al·legant mala pràctica o incompliment contractual per
              part del Comerç i, en aquest sentit, ho notifiqués a Nemuru
              acompanyant còpia de la interposició de la preceptiva demanda
              judicial o reclamació en matèria de consum corresponent, els fons
              no transferits al Comerç fins a la data quedaran retinguts, fins
              que l'Usuari i el Comerç notifiquin a Nemuru l'acord extrajudicial
              que, si s'escau, haguessin arribat o bé fins a la resolució, laudo
              o sentència judicial ferma que s'hagués dictaminat respecte de la
              demanda o reclamació que hagués interposat l'Usuari al Comerç. En
              aquest moment, Nemuru en base al pactat entre el Comerç i l'Usuari
              o al dictaminat en la resolució, laudo o sentència judicial ferma
              corresponent, procedirà a ordenar l'execució de l'ordre de
              transferència que procedeixi, ja sigui a favor del Comerç, si no
              s'hagués estimat la reclamació de l'Usuari, o bé a favor del
              Prestador, si s'hagués estimat la reclamació de l'Usuari, perquè
              en el seu cas apliqui els fons rebut a l'amortització total o
              parcial del Préstec.
            </p>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Dret de Desistiment</strong>
        </h3>
        <ol>
          <li>
            <h4>
              <strong>
                Exercici del dret de desistiment del Servei prestat per Nemuru:{" "}
              </strong>
            </h4>
            <span>
              L'Usuari tindrà dret a exercir el seu dret de desistiment respecte
              als Serveis a prestar per Nemuru en el marc d'aquests T&C de
              conformitat amb la normativa aplicable en cada moment.
            </span>
          </li>
          <li>
            <span>
              A aquests efectes, l'Usuari té un dret de desistiment en els
              catorze (14) dies naturals següents a la formalització del
              contracte, sense alegació de causa i sense penalització. Per
              exercir el dret de desistiment es posa a disposició de l'Usuari a
              la Plataforma un formulari de desistiment. El formulari és per
              sol·licitar el desistiment dels serveis que realitza Nemuru com a
              intermediari de la sol·licitud de préstec o Finançament que està
              requerint l'Usuari. El mateix té caràcter formal, ja que és una
              declaració jurada de les dades i la sol·licitud de l'Usuari.
              Important a saber que el formulari en cap cas és per finalitzar
              cap relació amb l'entitat financera o el Prestador en el cas que
              el crèdit estigui concedit. En aquest cas el procés és diferent,
              l'Usuari haurà de contactar amb Nemuru a través de les dades de
              contacte previstes en el present document.
            </span>
            <p>
              L'Usuari eximeix a Nemuru de qualsevol responsabilitat derivada de
              la utilització errònia del formulari de desistiment en els termes
              indicats en la present clàusula, renunciant a interposar cap
              reclamació davant Nemuru per això.
            </p>
            <p>
              En tot cas, l'ús del formulari de desistiment no és obligatori, ja
              que es pot desistir per qualsevol mitjà admès en dret. Davant
              qualsevol dubte, l'Usuari haurà de contactar amb Nemuru.
            </p>
          </li>
          <li>
            <h4>
              <strong>
                Exercici del dret de desistiment del Contracte de Préstec:{" "}
              </strong>
            </h4>
            <span>
              D'acord amb el que estableix la normativa aplicable, l'Usuari
              disposarà d'un termini de catorze (14) dies naturals per desistir
              del Contracte de Préstec, comunicant-ho al Prestador per qualsevol
              mitjà que permeti deixar constància sense indicació dels motius ni
              penalització alguna. A efectes aclaratoris, es fa constar que el
              dret a desistir del Contracte de Préstec no implica, de cap
              manera, el dret a desistir del contracte de prestació de serveis
              que l'Usuari hagués subscrit amb el Comerç o amb Nemuru, que es
              regirà per la seva normativa específica.
            </span>
            <p>
              L'Usuari eximeix a Nemuru de qualsevol responsabilitat derivada de
              l'actuació de Nemuru en els termes indicats en la present
              clàusula, renunciant a interposar cap reclamació davant Nemuru per
              això.
            </p>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Durada i Resolució</strong>
        </h3>
        <ol>
          <li>
            <h4>
              <strong>Durada: </strong>
            </h4>
            <span>
              Aquests T&C entraran en vigor en la data de la seva formalització
              i tindran una durada indefinida.
            </span>
          </li>
          <li>
            <h4>
              <strong>Resolució: </strong>
            </h4>
            <span>
              En tot cas les presents T&C es resoldran i quedaran sense efecte
              en els següents supòsits:
            </span>
            <ul>
              <li>
                Per mutu acord entre les Parts formalitzat de forma expressa i
                per escrit;
              </li>
              <li>
                A l'elecció de qualsevol de les Parts, sense necessitat de
                justificació alguna, amb un preavís mínim de deu (10) dies;
              </li>
              <li>
                A elecció de la Part no incomplidora, per l'incompliment
                substancial per l'altra Part d'alguna de les obligacions
                materials establertes en les presents Condicions, excepte quan
                l'incompliment fos subsanable i es subsanés dins dels cinc (5)
                dies naturals següents a la data en què es notifiqui i
                requereixi a la Part incumplidora per a la seva subsanació.
                Transcorregut aquest termini sense que l'incompliment s'hagués
                subsanat, la Part notificant podrà donar per resoltes les
                presents Condicions, mitjançant la seva notificació per escrit a
                la Part incumplidora i reclamar-li els danys i perjudicis que
                poguessin;
              </li>
              <li>
                De forma immediata, en el supòsit en què Nemuru tingui una
                sospita o indici sobre blanqueig de capitals i/o finançament del
                terrorisme o qualsevol altra activitat contrària a la Legislació
                Aplicable respecte de l'Usuari, així com en cas que es produeixi
                una situació relacionada amb l'Usuari que pugui implicar un
                impacte negatiu greu en la reputació i imatge de Nemuru o dels
                Prestadors; i
              </li>
              <li>
                De forma immediata, en el supòsit en què l'Usuari no accepti els
                nous termes i condicions d'aquests T&C notificades per Nemuru de
                conformitat amb el disposat a la clàusula 15.9 següent.
              </li>
            </ul>
          </li>
          <li>
            <h4>
              <strong>Efectes de la finalització o resolució: </strong>
            </h4>
            <span>
              La finalització i/o resolució d'aquests T&C es donarà sense
              perjudici dels drets i obligacions de les Parts que s'hagin
              adquirit abans d'aquesta terminació. En cas de finalització i/o
              rescissió serà d'aplicació el següent règim:
            </span>
            <ul>
              <li>
                La cessació automàtica dels Serveis i la impossibilitat
                d'utilitzar la Plataforma i beneficiar-se dels Serveis per part
                de l'Usuari;
              </li>
              <li>
                L'Usuari haurà d'abonar de forma immediata a Nemuru qualsevol
                quantitat pendent de pagament de forma prèvia a la resolució
                d'aquests T&C i, en tot cas, la contraprestació que s'hagués
                abonat de forma prèvia no serà reemborsable i, per tant,
                l'Usuari no podrà sol·licitar el reemborsament de la mateixa; i
              </li>
              <li>
                La finalització o resolució dels presents T&C no afectarà els
                Contractes de Préstec formalitzats de forma prèvia ni cap altre
                compromís assumit per part de l'Usuari en el marc de la
                Finançament amb el/s Prestador(s) i sense perjudici de les
                obligacions i responsabilitats incloses, si escau, davant Nemuru
                i els Prestadors en virtut d'aquests T&C, i
              </li>
              <li>
                Les obligacions, compromisos o pactes de les Parts previstos en
                aquests T&C que, per la seva naturalesa, hagin de seguir en
                vigor després de la finalització de les mateixes, seguiran sent
                d'aplicació, incloent, però sense limitar-se a això, les
                obligacions (inclosos importos pendents de pagament) assumides
                per l'Usuari en el marc de la Finançament o sota aquests T&C
                (tant si la mateixa és assumida amb Nemuru o amb el Prestador),
                o les obligacions o disposicions previstes en les clàusules 6.3,
                ‎7, ‎8, ‎9, ‎10, ‎11, ‎12, ‎13, ‎14 i ‎16 d'aquests T&C.
              </li>
            </ul>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Drets de Propietat Intel·lectual i Industrial</strong>
        </h3>
        <ol>
          <li>
            <h4>
              <strong>Drets de propietat intel·lectual i industrial: </strong>
            </h4>
            <span>
              Nemuru serà propietària i conservarà tots els drets, títols i
              interessos sobre qualsevol dret de propietat intel·lectual i
              industrial que ostentés de forma prèvia a aquests T&C o que
              desenvolupi durant o després de la vigència dels mateixos,
              incloent però sense limitar-s'hi, tots i cadascun dels drets de
              propietat industrial i/o intel·lectual de la Plataforma,
              documentació o materials associats als mateixos, incloent però
              sense limitar-s'hi a qualsevol programari i els seus algorismes,
              codis, procediments, idees o tècniques de qualsevol naturalesa,
              incloent els seus continguts i la materialització del mateix
              producte o disseny gràfic, text o imatge desenvolupat o creat per
              procediments fotogràfics, electroestàtics o informàtics, patents,
              marques, models d'utilitat, models i dibuixos industrials,
              topografies de productes semiconductors i qualssevol altres drets
              similars (<strong>"PI Nemuru”</strong> o <strong>”PI”</strong>).
              Salvo el disposat en aquests T&C, l'Usuari no podrà distribuir,
              vendre, reproduir, publicar, exhibir, representar, elaborar obres
              derivades o utilitzar de qualsevol altra manera la PI Nemuru o
              dels seus llicenciants sense el consentiment exprés previ per
              escrit de Nemuru.
            </span>
          </li>
          <li>
            <span>
              Salvo amb el permís expressa i per escrit de Nemuru, l'Usuari no
              pot (en tot o en part) copiar, distribuir, reproduir, adaptar,
              emmagatzemar, transmetre, desxifrar, desencriptar, imprimir,
              mostrar, comercialitzar, executar, publicar o crear obres
              derivades, oferir a la venda o utilitzar (excepte l'autoritzat
              expressament en aquests T&C) cap part del PI Nemuru. No se
              concedeix a l'Usuari cap dret, llevat dels expressament establerts
              en aquests T&C.
            </span>
          </li>
          <li>
            <span>
              A més, l'Usuari es compromet a no eludir, eliminar, alterar,
              desactivar, degradar o frustrar cap de les proteccions del
              contingut de la Plataforma o els Serveis; utilitzar qualsevol
              robot, spider, scraper o altre mitjà automatitzat per accedir a la
              Plataforma; descompilar, realitzar enginyeria inversa o
              desensamblar qualsevol programari o altres productes o processos
              accessibles a través de la Plataforma o el Servei; inserir
              qualsevol codi o producte o manipular el contingut de la
              Plataforma o els Serveis de qualsevol manera; o utilitzar
              qualsevol mètode de mineria, recopilació o extracció de dades. A
              més, l'Usuari es compromet a no carregar, publicar, enviar per
              correu electrònic o transmetre de cap altra manera qualsevol
              material dissenyat per interrompre, destruir o limitar la
              funcionalitat de qualsevol programari o maquinari informàtic o
              equip de telecomunicacions associat a la Plataforma o els Serveis,
              incloent qualsevol virus o qualsevol altre codi informàtic, arxius
              o programes.
            </span>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Llicència</strong>
        </h3>
        <ol>
          <li>
            Amb subjecció als presents T&C, durant la vigència d'aquests T&C
            Nemuru concedeix a l'Usuari una llicència limitada, revocable, no
            exclusiva, no sublicenciable i no transferible per utilitzar la
            Plataforma de Nemuru (la <strong>“Llicència”</strong>), amb
            subjecció als presents T&C i de conformitat amb ells. Aquesta
            Llicència té com a únic fi permetre-li utilitzar la Plataforma i
            beneficiar-se dels Serveis de la manera permesa per aquests T&C. No
            se concedeix a l'Usuari cap llicència o dret, llevat de la Llicència
            i drets que se li concedeixen expressament en el marc d'aquests T&C.
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Manifestacions i Garanties</strong>
        </h3>
        <ol>
          <li>
            L'Usuari manifesta i garanteix a Nemuru que:
            <ul>
              <li>
                Té capacitat legal i capacitat suficient als efectes de
                subscriure o acceptar aquests T&C, i donar compliment a la
                totalitat de les disposicions dels mateixos;
              </li>
              <li>
                Tota la informació, materials, documents, continguts facilitats
                a Nemuru seran veraces i legals i no incompliran cap disposició
                legal o drets de tercers i estaran en tot moment actualitzats;
              </li>
              <li>
                L'Usuari no utilitzarà els fons originats sota la Finançament
                amb la finalitat de finançar qualsevol activitat o negoci
                contrari a la Legislació Aplicable en cada moment; i
              </li>
              <li>
                L'Usuari reconeix i accepta el dret de Nemuru a posar fi de
                forma anticipada aquests T&C de forma immediata, sempre que les
                circumstàncies manifestades en aquesta clàusula variïn o es
                vegin alterades en qualsevol forma, i/o Nemuru no pugui garantir
                l'aplicació de la política de sancions, el compliment de la
                Legislació Aplicable, o fins i tot el compliment d'aquells
                requisits recomanats pels diferents organismes nacionals o
                internacionals als quals Nemuru hagi decidit vincular-se amb
                aquestes finalitats.
              </li>
            </ul>
          </li>
          <li>
            <span>
              En cas d'incompliment o manca de veracitat de les manifestacions i
              garanties que es detallen en aquesta clàusula, s'aplicarà el règim
              previst a la clàusula ‎10 següent, tot això sense perjudici de
              qualssevol altres drets que poguessin exercir les Parts de
              conformitat amb el disposat en aquests T&C o en la Legislació
              Aplicable.
            </span>
            <p>
              Amb l'objecte que Nemuru pugui complir adequada la normativa,
              l'Usuari es compromet a respectar, les normes i els procediments
              establerts o que es estableixin en el futur per ella (Nemuru),
              facilitant quanta informació o documentació resultés exigible en
              aplicació dels mateixos (procediments i normes).
            </p>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Responsabilitat i Incompliment</strong>
        </h3>
        <ol>
          <li>
            <span>
              Sense perjudici de la clàusula ‎11 següent, cada una de les Parts
              haurà d'indemnitzar i mantenir indemne a l'altra Part per
              qualsevol dany i perjudici que puguin patir com a conseqüència de
              (i) qualsevol incompliment de les seves respectives obligacions
              previstes en aquests T&C; i (ii) qualsevol incompliment o manca de
              veracitat o inexactitud de les manifestacions i garanties
              realitzades de conformitat amb la clàusula anterior.
            </span>
            <p>
              El que es disposa a l'apartat anterior serà sense perjudici de
              qualsevol altre dret o conseqüència prevista en els presents T&C,
              i del dret de la Part complidora a resoldre aquests T&C de
              conformitat amb el que s'estableix en els mateixos.
            </p>
            <p>
              La responsabilitat de qualsevol de les Parts per qualsevol
              incompliment d'aquests T&C donarà lloc al dret de l'altra Part a
              reclamar els danys i perjudicis que s'hagin produït i exigir en
              tot cas el compliment d'aquests T&C.
            </p>
          </li>
          <li>
            <span>
              Finalment, Nemuru es reserva el dret exclusiu de defensar
              directament o a través d'un tercer, qualsevol reclamació, demanda
              o procediment de qualsevol tipus, en virtut del qual Nemuru pugui
              arribar a tenir dret a qualsevol tipus d'indemnització de
              conformitat amb els presents T&C, sense que això limiti o
              restringeixi la responsabilitat de l'Usuari. En aquest cas,
              l'Usuari haurà de facilitar a Nemuru o a qualsevol tercer designat
              per Nemuru a aquest efecte, incloent-hi el Prestador, tota aquella
              documentació que raonablement sigui necessària per a dur a terme
              les actuacions anteriors, així com col·laborar amb Nemuru i amb
              qualsevol tercer designat a aquest efecte per Nemuru, incloent-hi
              el Prestador, en termes raonables.
            </span>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Exempció o Limitació de Responsabilitat</strong>
        </h3>
        <ol>
          <li>
            <span>
              Les Parts reconeixen i accepten que Nemuru no assumeix cap tipus
              de responsabilitat i/o obligació derivada de la Finançament i/o de
              qualsevol altre aspecte o incidència que es pugui donar en el marc
              de la concessió de la Finançament, ni derivada de la compra del
              producte o prestació del servei del Comerç finançat pel Prestador
              a l'Usuari.
            </span>
            <p>
              D'acord amb el que s'ha disposat al paràgraf anterior, ni Nemuru
              ni cap altra entitat del seu grup de societats serà en cap cas
              responsable del procés, la informació, el desemborsament de la
              Finançament, la documentació, el contingut entre altres, de les
              pantalles i avisos legals o textos legals del Prestador o del
              Comerç o referits a la Finançament, la compravenda dels productes
              o contractació dels serveis finançats, qualsevol o qualsevol altre
              incompliment de la Legislació Aplicable per part del Prestador i/o
              el Comerç. A més a més, Nemuru no es farà càrrec de la custòdia de
              les credencials de banca online de l'Usuari, cedint aquesta
              informació a un proveïdor d'informació de comptes de pagament, qui
              serà l'encarregat de custodiar i protegir aquesta informació. A
              aquest efecte, únicament conservaran les credencials de la banca
              online tokenitzades, sense conservar-se, en cap cas, la informació
              relativa a la targeta de crèdit o número de compte bancari.
            </p>
          </li>
          <li>
            <span>
              Addicionalment al que es disposa a la clàusula anterior, els
              Serveis, la Plataforma de Nemuru i tota la informació, productes i
              serveis proporcionats a través de la Plataforma de Nemuru es
              proporcionen "tal qual" “as is” i "segons disponibilitat" “as
              available”, i Nemuru no garanteix que la Plataforma de Nemuru o
              els Serveis siguin segurs, ininterromputs, precisos o lliures
              d'errors, o que la seva informació estigui segura i, a aquest
              efecte, l'Usuari renuncia de manera expressa a totes les garanties
              expressades o implícites de tot tipus, incloent-hi, però sense
              limitar-s'hi, garanties implícites d'exactitud o fiabilitat,
              validesa, disponibilitat, idoneïtat o integritat de qualsevol
              informació, contingut o dades proporcionades a través de la
              Plataforma de Nemuru i, per tant, en cap cas, Nemuru serà
              responsable per qualsevol reclamació, pèrdua, dany,
              responsabilitat, cost o despesa de qualsevol tipus, ja sigui
              directe o indirecte (inclosos els danys per lucrat cessant, pèrdua
              d'ingressos, beneficis, dades, ús, fons de comerç o altres pèrdues
              intangibles, reputacionals) o qualsevol altre dany de qualsevol
              tipus relacionat amb o causat per l'accés o l'ús de la Plataforma
              de Nemuru o els Serveis.
            </span>
          </li>
          <li>
            <span>
              Finalment, en la màxima mesura permesa per la Legislació
              Aplicable: (a) ni Nemuru ni cap entitat del seu grup de societats
              seran en cap cas responsables dels danys de qualsevol tipus, que
              es derivin de qualsevol manera de l'ús o la incapacitat d'usar els
              Serveis o la Plataforma de Nemuru el seu contingut o els
              materials, incloent, sense limitació cap, els danys que ocasioni o
              es derivin de la utilització, per part de l'Usuari, de qualsevol
              informació o material obtingut a través de la Plataforma de
              Nemuru, o que siguin conseqüència d'errors, omissions,
              interrupcions, eliminacions de fitxers o missatges de correu
              electrònic, errors, defectes, virus, retards en el funcionament o
              transmissió o qualsevol fallida de rendiment, ja sigui resultant o
              no de fets fortuïts, fallides en les comunicacions, robatoris o
              destrucció o accés no autoritzat als registres, programes o
              serveis de Nemuru; i (b) la responsabilitat total de Nemuru, ja
              sigui contractual, extracontractual o per garantia (incloent per
              negligència), responsabilitat per productes defectuosos,
              responsabilitat objectiva o responsabilitat derivada de qualsevol
              altre principi legal, en relació amb l'ús o la incapacitat d'usar
              els Serveis o la Plataforma de Nemuru, no excedirà en cap cas de
              l'import que hagi abonat l'Usuari en el marc del Servei que hagi
              generat el dany o perjudici, si escau. En la mesura en què la
              Legislació Aplicable impedeixi la limitació d'aquesta
              responsabilitat, Nemuru limitarà la seva responsabilitat en tot el
              permès per la Legislació Aplicable.
            </span>
            <li>
              <span>
                Les previsions disposades en la present clàusula seguiran
                vigents després de la finalització o resolució dels presents
                Termes i Condicions.
              </span>
            </li>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Protecció de Dades</strong>
        </h3>
        <ol>
          <li>
            <span>
              El tractament de les dades de l'Usuari es regirà d'acord amb la
              Política de Privacitat, on es descriuen les pràctiques
              d'informació, incloent-hi els tipus d'informació que Nemuru rep i
              recull per i del Usuari, així com el detall de com s'utilitza i es
              comparteix aquesta informació, i els drets de l'Usuari en relació
              amb el tractament de la informació sobre l'Usuari. La Política de
              Privacitat estableix les bases legals per al processament de la
              informació personal sobre l'Usuari, incloent-hi, entre altres, la
              recopilació, ús, processament i distribució d'aquesta informació,
              així com la transferència i processament d'aquesta informació on
              tinguem o utilitzem instal·lacions, proveïdors de serveis,
              empreses afiliades o socis, independentment d'on l'Usuari
              accedeixi a la Plataforma.
            </span>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Confidencialitat</strong>
        </h3>
        <ol>
          <li>
            <h4>Confidencialitat: </h4>
            <span>
              L'Usuari es compromet a: (a) protegir i no divulgar la informació
              posada a disposició per Nemuru que estigui identificada com a
              confidencial o que raonablement hagi de considerar-se
              confidencial; (b) utilitzar aquesta informació només per complir
              amb les seves obligacions en virtut d'aquests T&C; (c) no eliminar
              cap avís o marca de drets d'autor, avís de marca registrada i/o
              qualsevol altra llegenda de propietat establerta o continguda en
              qualsevol de la informació confidencial; i (d) destruir o retornar
              a Nemuru tota aquesta informació amb promptitud quan aquests T&C
              terminin (i, a petició de Nemuru, confirmar aquesta destrucció per
              escrit). Aquesta clàusula abasta tota la informació confidencial,
              independentment del moment en què l'Usuari la rebi.
            </span>
            <p>
              Les obligacions assumides en virtut d'aquesta clàusula seguiran
              sent plenament vigents després de la finalització o resolució dels
              presents T&C, mentre la informació confidencial sigui secreta i
              confidencial.
            </p>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Notificacions</strong>
        </h3>
        <ol>
          <li>
            <span>
              Totes les comunicacions, notificacions, consentiments i altres
              comunicacions requerides o permeses en virtut d'aquests T&C es
              faran per escrit i en espanyol, i de manera fehacient (aportant
              proves de la seva recepció i lectura). En particular, totes les
              comunicacions, notificacions, consentiments i altres comunicacions
              s'enviaran a l'adreça següent:
            </span>
            <div style={{ paddingTop: "8px" }}>
              <strong>Nemuru: </strong>
              <div>A l'atenció de: Suport Nemuru</div>
              <div>
                Adreça: Edifici Palau de Mar, Plaça Pau Vila, número 1, 1ª
                planta, sector AD, oficina 1AD, Barcelona
              </div>
              <div>Email: hola@nemuru.com</div>
              <div>Telèfon: +34 932 200 612</div>
            </div>
            <div style={{ paddingTop: "8px" }}>
              <strong>Usuari: </strong>
              email i/o adreça postal facilitada per l'Usuari en el procés de
              registre a la Plataforma. Es considerarà que l'Usuari ha rebut
              totes les comunicacions enviades a aquestes adreces, fins i tot si
              la mateixa ja no fos vigent.
            </div>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Miscel·lània</strong>
        </h3>
        <ol>
          <li>
            <h4>
              Pòlissa d'Assegurança de Responsabilitat Civil Professional:{" "}
            </h4>
            <span>
              Nemuru és titular de la pòlissa d'assegurança de responsabilitat
              civil professional PI-61693020M0, contractada a través de
              l'agència de subscripció Dual Ibèrica Riscos Professionals S.A.U.
              per compte de Liberty Mutual Insurance Europe SE i Lloyd’s
              Insurance Company S.A.
            </span>
          </li>
          <li>
            <h4>Qualitat i Codis Ètics: </h4>
            <span>
              Nemuru és una entitat adherida a Confianza Online (Associació
              sense ànim de lucre), inscrita al Registre Nacional d'Associacions
              Grup 1, Secció 1, número nacional 594400, CIF G85804011, Carrer la
              Palma 59, Baixos A., 28015 Madrid (Espanya). Per a més informació:
              (www.confianzaonline.es).
            </span>
            <p>
              Aquests T&C es regeixen per la legislació espanyola. Així mateix,
              en compliment del que disposa la Llei de Resolució Alternativa de
              Litigis, informem els consumidors que, com a entitat adherida i en
              els termes dels Codi Ètics, els usuaris podran acudir a Confianza
              Online per a la resolució alternativa d'eventuals controvèrsies
              Formulari de Reclamacions.
            </p>
            <p>
              Si aquestes es refereixen a transaccions electròniques amb
              consumidors, o sobre protecció de dades quan estiguin relacionades
              amb aquest àmbit, les reclamacions seran resoltes pel Comitè de
              Mediació de Confianza Online, acreditat per a la resolució
              alternativa de litigis en matèria de consum. Si les reclamacions
              versen sobre publicitat digital, o sobre protecció de dades
              relacionada amb aquest àmbit, seran sotmeses al Jurat de la
              Publicitat de AUTOCONTROL.
            </p>
            <p>
              A més, se li recorda a l'Usuari que pot accedir a la plataforma de
              resolució de litigis en línia de la Unió Europea seguint aquest
              enllaç:
              <a href="https://ec.europa.eu/consumers/odr" target="_blank">
                Plataforma Resolució de litigis de la Unió Europea
              </a>
            </p>
          </li>
          <li>
            <h4>Accés a les dades: </h4>
            <span>
              L'Usuari autoritza i accepta que Nemuru es connecti o accedeixi
              directament o a través de qualsevol tercer designat per Nemuru a
              les dades que es derivin dels Serveis, amb l'objectiu de
              recopilar, agregar, compilar i utilitzar aquestes dades de la
              manera que Nemuru consideri oportuna, incloent-hi iniciatives de
              qualitat, l'avaluació comparativa, els serveis d'informació o la
              millora dels Serveis, entre altres. Les dades recollides o
              recabades per Nemuru s'utilitzaran, durant i després de la
              resolució o finalització d'aquests T&C, mantenint sempre el mateix
              nivell de confidencialitat respecte a l'Usuari.
            </span>
          </li>
          <li>
            <h4>Subcontractació: </h4>
            <span>
              Nemuru podrà subcontractar qualsevol treball o servei a realitzar
              en el marc del present document. En tot cas, Nemuru continuarà
              estant obligada al compliment degut i puntual de qualsevol
              obligació subcontractada en el marc del present document.
            </span>
          </li>
          <li>
            <h4>Epígrafs, títols i separabilitat: </h4>
            <span>
              Els epígrafs i títols del present document s'han inclòs únicament
              per facilitar-ne la lectura i no pretenen en cap cas descriure el
              contingut de les corresponents Clàusules ni representar
              compromisos, termes o condicions del present document.
            </span>
            <p>
              Si es determina que alguna disposició del present document és
              invàlida o inaplicable en la seva totalitat o en part, per
              qualsevol motiu present o futur, aquesta invalidesa o
              inaplicabilitat no afectarà l'aplicabilitat de cap de les
              disposicions restants del mateix. El present document
              s'interpretarà com si aquestes disposicions invàlides o
              inaplicables mai haguessin estat contingudes en el mateix. A
              aquests efectes, el document deixarà de ser vàlid exclusivament
              respecte a la disposició nul·la o invàlida, i cap de les altres
              parts o disposicions del present document serà nul·la, invàlida,
              perjudicada o afectada per aquesta nul·litat o invalidesa, llevat
              que per resultar essencial per als Serveis hagi d'afectar el
              present document en el seu conjunt.
            </p>
          </li>
          <li>
            <h4>Acord Íntegre: </h4>
            <span>
              Aquest document i els seus annexos, si n'hi ha, constitueixen
              l'acord íntegre entre les Parts en relació amb l'objecte del
              mateix i substitueixen qualsevol altre pacte o acord previ, escrit
              o verbal, existent entre les Parts que versin sobre aquesta
              matèria.
            </span>
          </li>
          <li>
            <h4>Renúncia d'accions: </h4>
            <p>
              La renúncia o el no exercici dels drets de qualsevol de les Parts
              en virtut del present document no es considerarà una renúncia o
              limitació de cap altre dret o de qualsevol dret futur. Tota
              renúncia s'ha de fer per escrit i ser acceptada expressament per
              la Part a qui se li imputa.
            </p>
          </li>
          <li>
            <h4>Cessió: </h4>
            <span>
              L'Usuari no podrà cedir o transferir els seus drets o obligacions
              en virtut d'aquest document, en la seva totalitat o en part, a cap
              tercer sense el previ consentiment exprés i per escrit de Nemuru.
              Nemuru podrà cedir els seus drets i obligacions en virtut del
              present document sense necessitat d'obtenir el consentiment de
              l'Usuari.
            </span>
          </li>
          <li>
            <h4>Modificacions: </h4>
            <span>
              Nemuru pot modificar, afegir o eliminar aquest document i el
              contingut de la Plataforma en qualsevol moment i a la seva entera
              i lliure discreció. En tot cas, Nemuru notificarà abans de
              qualsevol canvi d'aquests T&C quan segueixin essent d'aplicació
              als Usuaris. Si l'Usuari no està d'acord amb les noves condicions,
              haurà d'interrumpre l'accés i l'ús de la Plataforma i els Serveis.
              El seu ús i accés a la Plataforma i/o als Serveis després de
              qualsevol modificació d'aquest acord es considerarà una acceptació
              tàcita o implícita de totes les modificacions.
            </span>
          </li>
          <li>
            <h4>Força Major: </h4>
            <span>
              Cap de les Parts serà responsable de qualsevol fallida o retard en
              el compliment de les seves obligacions en virtut d'aquest document
              per qualsevol causa més enllà del control raonable d'aquesta Part,
              incloent-hi, però sense limitar-se a això, els tallades elèctrics,
              el fallida dels proveïdors de serveis d'Internet, el incompliment
              a causa de la interrupció d'Internet (incloent, sense limitació,
              els atacs de denegació de servei), els disturbis, la insurrecció,
              els actes de terrorisme, la guerra (o similars), els incendis, les
              inundacions, les pandèmies, els terratrèmols, les explosions i
              altres actes fora del control de les Parts.
            </span>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Llei i Jurisdicció Aplicables</strong>
        </h3>
        <ol>
          <li>
            <span>
              Aquests T&C i l'accés i ús de la Plataforma i dels Serveis es
              regiran de forma exclusiva per la legislació espanyola, excloent
              expressament l'aplicació de qualsevol altra norma o legislació que
              pogués arribar a ser d'aplicació.
            </span>
          </li>
          <li>
            <span>
              Qualsevol disputa, controvèrsia, conflicte o reclamació que pogués
              derivar-se de la interpretació o execució d'aquests T&C
              (incloent-hi la Política de Privacitat i la Política de Cookies),
              o relacionats de forma directa o indirecta amb la utilització de
              la Plataforma o la prestació dels Serveis, s'haurà de sotmetre de
              forma exclusiva als Jutjats i Tribunals de la Ciutat de Barcelona
              (Espanya).
            </span>
          </li>
        </ol>
      </li>
    </ol>
  </div>
);
